import { WithStyles } from "@material-ui/core";
import * as ParcelBidNodeCss from "../../../styles/ParcelBidNodeCss";

type ParcelBidTimelineProps = {
    classes: WithStyles<typeof ParcelBidNodeCss.styles>["classes"];
    position: ParcelBidNodeCss.TimelinePosition;
};

// Draws a node's piece of the dashed timeline.
export default function ParcelBidTimeline({
    classes,
    position
}: ParcelBidTimelineProps) {
    if (position === "single") return null;

    let wrapperClasses = classes.timeline;
    let lineClasses = classes.timelineTopLine;

    if (position === "start") {
        wrapperClasses += ` ${classes.timelineStart}`;
        lineClasses += ` ${classes.timelineStartOrEndLine} ${classes.timelineStartLine}`;
    } else if (position === "end") {
        wrapperClasses += ` ${classes.timelineEnd}`;
        lineClasses += ` ${classes.timelineStartOrEndLine} ${classes.timelineEndLine}`;
    }

    return (
        <div className={wrapperClasses} data-testid="bid-timeline">
            <div className={lineClasses} />
        </div>
    );
}
